import React from 'react';
import PropTypes from 'prop-types';

export const DocumentList = ({ documentsList = [], onClickDocumentItem }) => {
    const drawDocumentItems = () => {
        if (!Array.isArray(documentsList)) {
            return null;
        }

        return documentsList.map(document => {
            const { documentName, documentType, isAccepted } = document;
            const iconClass = isAccepted ? 'icons--icon-success-green-dic' : 'icons--icon-document-dic';
            const itemAcceptedClass = isAccepted ? ' documentation-doc-list-item--accepted' : '';

            return (
                <li
                    className={`documentation-doc-list-item${itemAcceptedClass}`}
                    onClick={() => onClickDocumentItem(document)}
                    key={documentType}
                >
                    <i className={iconClass}></i>
                    <span>{documentName}</span>
                </li>
            );
        });
    };

    return <ul className="documentation-doc-list">{drawDocumentItems()}</ul>;
};

DocumentList.propTypes = {
    documentsList: PropTypes.array,
    onClickDocumentItem: PropTypes.func,
};
